<template>
  <section class="section" id="stockouts-panel">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
        :can-cancel="false"
      ></b-loading>

      <stockouts-title
        @update-dates="updateDates"
        @get-stockouts="getStockouts"
        @download-report="downloadStockoutsReport"
      />

      <h2 v-if="!touched" class="subtitle has-text-centered">
        {{ $t("stockouts.selectPeriodOrClickToUpdate") }}
      </h2>

      <div v-else>
        <h2 v-if="stockouts.length === 0" class="subtitle has-text-centered">
          {{ $t("stockouts.noStockoutsAtThisPeriod") }}
        </h2>

        <div v-else style="margin-bottom: 2rem">
          <stockouts-table :stockouts="stockouts" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import stockoutsTitle from "./StockoutsTitle";
import stockoutsTable from "./StockoutsTable";

export default {
  mixins: [common],

  components: {
    stockoutsTitle,
    stockoutsTable
  },

  data() {
    return {
      isLoading: false,
      touched: false,
      dates: []
    };
  },

  methods: {
    getStockouts() {
      this.isLoading = true;
      this.touched = true;
      this.$store
        .dispatch("getStockouts", {
          dates: this.dates
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    updateDates(dates) {
      this.dates[0] = dates
        ? this.moment(dates[0]).format("YYYY-MM-DD")
        : this.moment().format("YYYY-MM-DD");

      this.dates[1] = dates
        ? this.moment(dates[1]).format("YYYY-MM-DD")
        : this.moment().format("YYYY-MM-DD");
    },

    downloadStockoutsReport() {
      this.isLoading = true;
      this.$store
        .dispatch("downloadStockoutsReport", {
          beginDate: this.dates[0],
          endDate: this.dates[1]
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters(["stockouts"])
  },

  mounted() {
    this.updateDates();
  }
};
</script>

<style scoped>
#stockouts-panel {
  margin-top: 3rem;
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}
</style>
